import {action, IObservableArray, makeObservable, observable} from "mobx";
import {GridApi} from "ag-grid-community";

export class UserListStore {
    gridApi: GridApi = null;
    constructor() {
        makeObservable(this);
    }

    @observable editedUserID: string = "";
    @observable addUser: boolean = false;
    @observable editUser: boolean = false;
    @observable userLogin:string = "";
    @observable userPassword:string ='';
    @observable wantsToChangePassword: boolean = false;
    @observable canSaveTranslation: boolean = false;
    @observable userPrivilege: string = '';
    @observable open: boolean = false;
    @observable openAlert: boolean = false;

    mainLanguagesChosenIdSet: IObservableArray<string> = observable.array([]);
    targetLanguagesChosenIdSet: IObservableArray<string> = observable.array([]);

    @action
    clear() {
        //render
        this.addUser = false;
        this.editUser = false
        this.userLogin = "";
        this.userPassword= '';
        this.canSaveTranslation = false;
        this.wantsToChangePassword = false;
        this.mainLanguagesChosenIdSet.clear();
        this.targetLanguagesChosenIdSet.clear();
        //render
    }

    @action
   handleOpen () {
        this.open = !this.open
        this.wantsToChangePassword = false;
        if (this.wantsToChangePassword == false) {
            this.userPassword = ''
        }

    }

    @action
     handleClose ()  {
        this.open = false
        this.wantsToChangePassword = false;
        if (this.wantsToChangePassword == false) {
            this.userPassword = ''
        }
    };

    @action
    handleOpenAlert () {
        this.openAlert = !this.openAlert
    }

    @action
    handleCloseAlert ()  {
        this.openAlert = false
    };

}

